import * as React from "react";
import { connect } from "react-redux";
import { IdErrorCore } from "../../constants/IdErrorCore";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { actionErrorResolveError } from "../errors/actionError";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionPlayerXpClearHighScores } from "./actionRanking";
export var MenuPlayerRankingDOM = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(MenuWrapper, { type: IdMenuBalancing.RankingMenu, onClose: onClose, modalId: IdModal.PlayerRanking }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () {
        dispatch(actionModalClose(IdModal.PlayerRanking));
        dispatch(actionErrorResolveError(IdErrorCore.TextErrors));
        dispatch(actionPlayerXpClearHighScores());
    },
}); };
export var MenuPlayerRanking = connect(undefined, mapDispatch)(MenuPlayerRankingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/MenuPlayerRanking.tsx
// module id = 2895
// module chunks = 3